import moment from 'moment'
import React,{useState,useEffect,useRef} from 'react'
import { Permissions } from '../../helpers/permission'
import { Role } from '../../sdk'
import { Loader } from '../Default'
import { DataTable } from '../Default/DataTables/DataTable'
import { toasterFunction } from '../Default/ToasterComponent'
export const MainContent=()=> {
  const [state,setState]=useState({loader:true,date:moment().format("yyyy-MM-DD"),actualData:[],data:[[1,"ANAS","Admin",`<button type="button" class="btn btn-danger delete"><i class="fa fa-trash" aria-hidden="true"></i></button> <button type="button" class="btn btn-default update"><i class="fa fa-pencil" aria-hidden="true"></i></button>`]],
  tbHeader:[{title:"#",name:"count"},{title:"Name",name:"name"},{title:"Permissions",name:"permissions"},{title:"Operations",name:"operations"}],
  updated:false,tableLoader:false,
  buttonLoader:false,
  buttonDisabled:false,
  count:1,
  formAttr:{
    name:"",
    permissions:[]
  },
  updateFormAttr:{
    name:"",
    permissions:[], 
    id:0,
    index:0,
  }
  });
  const ref=useRef();
  const ref2=useRef();
  const onHandler=(event)=>{
    let key=event.target.name;
    let value=event.target.value;
    let oldState={...state}
    if(key==="name"){
      oldState.formAttr.name=value;
    }
    else{
      oldState.formAttr.permissions=oldState.formAttr.permissions.includes(value)?oldState.formAttr.permissions.filter(val=>val !==value):[...oldState.formAttr.permissions,...[value]];
    }
    setState((pre)=>{
      return {...pre,...oldState}
    })
    
  }
  const onUpdateHandler=(event)=>{
    let key=event.target.name;
    let value=event.target.value;
    let oldState={...state}
    if(key==="name"){
      oldState.updateFormAttr.name=value;
    }
    else{
      oldState.updateFormAttr.permissions=oldState.updateFormAttr.permissions.includes(value)?oldState.updateFormAttr.permissions.filter(val=>val !==value):[...oldState.updateFormAttr.permissions,...[value]];
    }
    setState((pre)=>{
      return {...pre,...oldState}
    })
    
  }

  const apiData=async()=>{
    try{
    let result=await new Role().get();

   if(result.length){
      let arr=[];
       let count=1;
      for(let val of result){
       arr.push([count,val.name,val.permissions.join(","),`<button type="button" class="btn btn-danger delete" data-index=${count} data-id=${val._id}><i class="fa fa-trash" aria-hidden="true"></i></button> <button type="button" class="btn btn-default update" data-index=${count} data-id=${val._id}><i class="fa fa-pencil" aria-hidden="true"></i></button>`])
       count++;
      }
      setState((pre)=>{
        return {...pre,data:arr,loader:false,tableLoader:false,actualData:result,count}
     })
    }
    else{
      
      setState((pre)=>{
        return {...pre,data:[],loader:false,tableLoader:false,actualData:[]}
     })
    }
   
    }catch(e){
      console.log(e)
    alert("error occur")
    }

}
const onDelete=async(id,index)=>{
 try{
  if(window.confirm("are you want to delete this")){
    await new Role().delete({id});
    let oldState={...state};
    toasterFunction.success("role has been deleted")
    oldState.data=oldState.data.filter(val=>Number(val[0]) !==Number(index));
    oldState.actualData=oldState.actualData.filter(val=>Number(val.id) !==Number(id));
    setState((pre)=>{
      return {...pre,...oldState}
    })
  }
 
}catch(e){
console.log(e);
}
}
const onUpdate=(id,index)=>{
  let data=state.actualData.find(val=>val._id===id);
 if(data){
  let oldState={...state};
  oldState.updateFormAttr={...oldState.updateFormAttr,...data,id,index};
  window.$("#showEditForm").modal("show")
  setState((pre)=>{
    return {...pre,...oldState}
  })
 }
 else{
  alert("data not found")
 }
  
}
const modalHandler=(id=false)=>{
window.$("#showForm").modal("show")
}
const onSubmitAdd=async (event)=>{
  event.preventDefault();
 
 try{
if(!state.formAttr.permissions.length){
toasterFunction.error("please select alteast one permission")
return false;
}  
 ref.current.disabled=true;
  ref.current.firstElementChild.style.display="inline-block"
await new Role().add({...state.formAttr,permissions:JSON.stringify(state.formAttr.permissions)});
toasterFunction.success("role has been added")
window.location.reload();
// oldState.data=[[oldState.count,result.name,JSON.parse(result.permissions).join(),`<button type="button" class="btn btn-danger delete" data-index=${oldState.count}  data-id=${result.id}><i class="fa fa-trash" aria-hidden="true"></i></button> <button type="button" class="btn btn-default update" data-index=${oldState.count} data-id=${result.id}><i class="fa fa-pencil" aria-hidden="true"></i></button>`],...oldState.data];
// oldState.actualData.push(result);
// oldState.count=oldState.count +1;
// ref.current.disabled=false;
// ref.current.firstElementChild.style.display="none"
// window.$(".modal").modal("hide");
// setState((pre)=>{
//   return {...pre,...oldState}
// })

}catch(e){
if(e.response.status===300){
  toasterFunction.error("name already taken")
}
else{
  toasterFunction.error(e.response.data.message)
}

}finally{
   ref.current.disabled=false;
ref.current.firstElementChild.style.display="none"
}
}
const onSubmitUpdate=async (event)=>{
  event.preventDefault();
 
 
try{
if(!state.updateFormAttr.permissions.length){
toasterFunction.error("please select alteast one permission")
return false;
}  
 ref2.current.disabled=true;
  ref2.current.firstElementChild.style.display="inline-block"
await new Role().update({...state.updateFormAttr,permissions:JSON.stringify(state.updateFormAttr.permissions)});
toasterFunction.success("role has been updated");
window.location.reload();


}catch(e){
  console.log(e);
if(e.response.status===300){
  toasterFunction.error("name already taken")
}
else{
  toasterFunction.error(e.response.data.message)
}

}finally{
  ref2.current.disabled=false;
ref2.current.firstElementChild.style.display="none"
}
}

useEffect(()=>{
apiData();
},[])
if(!state.loader){
  return (
    <>
      <div className="card mb-3">
       {/* BEGIN card-body */}
       <div className="card-body">
   <div className="col-12 mb-4">
     <div className="row" style={{textAlign:"center"}}>
       <div className="col-12">
       <div className="fw-bold mb-3">
   <span className="flex-grow-1 text-white">Role</span>
   </div> 
       </div>
       <div className="col-10"></div>
       <div className="col-2" style={{textAlign:"end"}}>
       <button type="button" class="btn btn-theme" onClick={modalHandler}>Add new Role</button>
       </div>
      
     </div>
  
   </div>
   {state.tableLoader && <><Loader/></>}
   
   <div className="col-12">
  <DataTable headers={state.tbHeader} data={state.data} image={true} updated={state.updated} parentFun={{onUpdate,onDelete}}/>
  
   </div>
   </div>
   <div className="card-arrow">
         <div className="card-arrow-top-left" />
         <div className="card-arrow-top-right" />
         <div className="card-arrow-bottom-left" />
         <div className="card-arrow-bottom-right" />
       </div>
   </div>
   
   <div class="modal" id="showForm">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add New Role</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitAdd}>
          <div className="row">
          <div className="col-xl-12" >
          <div className="form-group mb-3 w-50">
          <label className="form-label text-white" >
              Role Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Role Name"
              name='name'
              value={state.formAttr.name}
              onChange={onHandler}
              required
            />
          </div>
        </div>
     
       <div className="col-xl-12">
													<div className="small text-white mb-1"><b>Permission</b></div>
													<div className="form-group mb-4">
                          {Permissions.map((val2,index2)=>{
                              return (<>
                                <div className="form-check form-check-inline">
                                 <input className="form-check-input" type="checkbox" id={`defaultCheck${index2}`} name='permissions' value={val2} onChange={onHandler} checked={(state.formAttr.permissions.includes(val2))}/>
                                 <label className="form-check-label" htmlFor={`defaultCheck${index2}`}>{val2}</label>
                               </div>
                             
                                </>)
                            
                            
                            })}
													
													</div>
					</div>
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="submit" class="btn btn-outline-theme w-25" ref={ref} disabled={false}>Add <div className="spinner-border" role="status" style={{height:"15px",width: "1rem" ,display:"none"}}></div></button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    </div>
     
     
    </div>
  </div>
</div>
<div class="modal" id="showEditForm">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit Role</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitUpdate}>
          <div className="row">
          <div className="col-xl-12" >
          <div className="form-group mb-3 w-50">
          <label className="form-label text-white" >
              Role Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Role Name"
              name='name'
              value={state.updateFormAttr.name}
              onChange={onUpdateHandler}
              required
            />
          </div>
        </div>
     
       <div className="col-xl-12">
													<div className="small text-white mb-1"><b>Permission</b></div>
													<div className="form-group mb-4">
                          {Permissions.map((val2,index2)=>{
                           
                              return (<>
                                <div className="form-check form-check-inline">
                                 <input className="form-check-input" type="checkbox" id={`defaultCheck${index2}`} name='permissions' value={val2}  onChange={onUpdateHandler} checked={(state.updateFormAttr.permissions.includes(val2))}/>
                                 <label className="form-check-label" htmlFor={`defaultCheck${index2}`}>{val2}</label>
                               </div>
                             
                                </>)
                            
                            
                            })}
													
													</div>
					</div>
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="submit" class="btn btn-outline-theme w-25" ref={ref2} disabled={false}>Edit <div className="spinner-border" role="status" style={{height:"15px",width: "1rem" ,display:"none"}}></div></button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    </div>
     
     
    </div>
  </div>
</div>


 </>
 
    
   )
}
else{
  return (<>
  <Loader/>
  </>)
}
  
}
